import { render, staticRenderFns } from "./RelatedJewels.vue?vue&type=template&id=7b68eae1&scoped=true&"
import script from "./RelatedJewels.vue?vue&type=script&lang=js&"
export * from "./RelatedJewels.vue?vue&type=script&lang=js&"
import style0 from "./RelatedJewels.vue?vue&type=style&index=0&id=7b68eae1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b68eae1",
  null
  
)

export default component.exports